/** Screen 7 — "Does this look like you": branding + copy beside the live preview. */
import { useDraftContinue } from '../config/draft';
import { PublishBar } from '../config/PublishBar';
import { BrandingSection } from '../config/sections/BrandingSection';
import { CopySection } from '../config/sections/CopySection';
import { EditorWithPreview } from '../config/PreviewDock';
import { WithSiteDraft } from '../config/WithSiteDraft';
import { OnboardingPage } from '../setup/OnboardingPage';
import { useSites } from '../state/sites';

function Body() {
  const footer = useDraftContinue();
  const { current } = useSites();
  return (
    <OnboardingPage
      slug="branding"
      lede="Your colours and words, checked for contrast as you go. The preview is the real widget running this draft."
      {...footer}
    >
      <EditorWithPreview siteKey={current?.test?.site_key ?? current?.live.site_key ?? ''}>
        <div className="stack-lg">
          <BrandingSection />
          <CopySection />
        </div>
      </EditorWithPreview>
      <PublishBar hasTestKey={Boolean(current?.test)} />
    </OnboardingPage>
  );
}

export function Branding() {
  return (
    <WithSiteDraft>
      <Body />
    </WithSiteDraft>
  );
}
